module.exports = __webpack_public_path__ + "img/chrom-min.5e971a2e.png";